import React from 'react';
import clsx from 'clsx';
import { getRoundedValue, getMetric } from './../utils';
import { CPAL_METRICS } from './../../../../constants/metrics';

var NonInteractiveScale = function NonInteractiveScale(_ref) {
  var metric = _ref.metric,
      quintiles = _ref.quintiles,
      colors = _ref.colors,
      showHash = _ref.showHash,
      hashLeft = _ref.hashLeft,
      showMinMax = _ref.showMinMax;
  var metricData = getMetric(metric, CPAL_METRICS); // console.log(
  //   'NonInteractiveScale, metricData.colors ',
  //   metricData.colors,
  //   'quintiles, ',
  //   quintiles,
  // )

  var styles = [{
    backgroundColor: !!quintiles[0] ? colors[0] : 'transparent'
  }, {
    backgroundColor: !!quintiles[1] ? colors[1] : 'transparent'
  }, {
    backgroundColor: !!quintiles[2] ? colors[2] : 'transparent'
  }, {
    backgroundColor: !!quintiles[3] ? colors[3] : 'transparent'
  }, {
    backgroundColor: !!quintiles[4] ? colors[4] : 'transparent'
  }];
  var hashStyles = {
    left: hashLeft + '%'
  };
  var minMaxStyle = {
    display: !!showMinMax ? 'block' : 'none'
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "n-i-scale",
    key: metric
  }, /*#__PURE__*/React.createElement("div", {
    className: "n-i-scale-parent"
  }, !!showHash ? /*#__PURE__*/React.createElement("div", {
    className: "n-i-scale-hash",
    style: hashStyles
  }) : null, /*#__PURE__*/React.createElement("div", {
    className: clsx('n-i-scale-quintiles', 'metric-' + metric)
  }, /*#__PURE__*/React.createElement("div", {
    className: "n-i-scale-quintile quintile-0",
    style: styles[0]
  }), /*#__PURE__*/React.createElement("div", {
    className: "n-i-scale-quintile quintile-1",
    style: styles[1]
  }), /*#__PURE__*/React.createElement("div", {
    className: "n-i-scale-quintile quintile-2",
    style: styles[2]
  }), /*#__PURE__*/React.createElement("div", {
    className: "n-i-scale-quintile quintile-3",
    style: styles[3]
  }), /*#__PURE__*/React.createElement("div", {
    className: "n-i-scale-quintile quintile-4",
    style: styles[4]
  }))), !!showMinMax ? /*#__PURE__*/React.createElement("div", {
    className: "n-i-scale-minmax",
    style: minMaxStyle
  }, /*#__PURE__*/React.createElement("div", {
    className: "n-i-scale-min"
  }, getRoundedValue(!!metricData.high_is_good ? metricData.range[0] : metricData.range[1], metricData.decimals, false, !!metricData.is_currency, !!metricData.as_percent)), /*#__PURE__*/React.createElement("div", {
    className: "n-i-scale-max"
  }, getRoundedValue(!!metricData.high_is_good ? metricData.range[1] : metricData.range[0], metricData.decimals, false, !!metricData.is_currency, !!metricData.as_percent))) : '');
};

export default NonInteractiveScale;